/* ==========================================================================
   SearcherFlight > Client > Discount > Panel > Resident
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');
const ViewHelpers = require('@bluekiri/alexandria/core/ViewHelpers');

const { fromEvent } = require('rxjs');

const { addModal } = require('./modal');

const renderTrigger = content => html(`<span class='searcher__trigger' data-trigger>${content}</span>`);

/* Render */
function renderResident(instance) {
    /* Data */
    const { context, resident } = instance.config;
    const { label, content } = resident;

    /* View Helpers */
    const { icon, markdown } = ViewHelpers(context);

    const text = markdown(content).replace(/\{.*?}/, match => renderTrigger(match.replace(/\{?\}?/g, '')));

    return html(`
        <div data-resident>
            <p class='searcher__title'>${label}</p>
            <p class='searcher__information'>
                <span class='searcher__icon'>${icon('info')}</span>
                <span>${text}</span>
            </p>
        </div>
    `);
}

/* Init */
function initResident(instance) {
    const panel = instance;

    /* Reference */
    panel.resident = {
        trigger: instance.discountPanel.element.querySelector('[data-resident] [data-trigger]')
    };

    /* Subscriptions */
    panel.subscriptions = {
        ...instance.subscriptions,
        openResidentModal: fromEvent(instance.resident.trigger, 'click').subscribe(event => {
            event.stopPropagation();

            /* Add Modal */
            addModal(instance);
        })
    };
}

/* Destroy */
function destroyResident(instance) {
    const panel = instance;

    /* Subscriptions */
    instance.subscriptions.openResidentModal.unsubscribe();
    delete panel.subscriptions.openResidentModal;

    /* Reference */
    delete panel.resident;
}

/* Exports */
module.exports = {
    renderResident,
    initResident,
    destroyResident
};
